<template>
  <material-card
    class="card-tabs col-12"
    color="green"
    title="Recent Transactions"
    style="margin-top: 0px;"
  >
    <v-data-table
      :headers="headers"
      :items="items"
      :loading="loading"
      :options.sync="options"
      @update:options="updateOpt"
      :server-items-length="total"
      :footer-props="{'items-per-page-options': [15, 25, 50, 100]}"
      :items-per-page="15"
      sort-by="created"
      sort-desc
      height="530"
      fixed-header
      style="z-index: 0; position: relative;"
    >
    </v-data-table>
  </material-card>
</template>

<script>

  import _ from 'lodash'
  import moment from 'moment'
  import { API } from '@/utils/api'
  import { mapGetters } from 'vuex'

  export default {

    props: [],

    data: () => ({
      items: [],
      options: {},
      loading: true,
      total: null,
      headers: [
        { text: 'Created', value: 'created' },
        { text: 'Finished', value: 'completed' },
        { text: 'ID', value: 'account_transaction_id', sortable: true },
        { text: 'Alias', value: 'alias', sortable: true },
        { text: 'Description', align: 'left', sortable: false, value: 'comment' },
        { text: 'Debit/Credit', value: 'amount', sortable: false },
        { text: 'Type', value: 'type', sortable: false },
        { text: 'Status', value: 'status', sortable: false },
        { text: 'Paymethod', value: 'paymethod', sortable: false },
        { text: 'Paysystem', value: 'paysystem', sortable: false },
      ],
    }),

    computed: {},

    methods: {
      updateOpt (val) {

        API.call('/$v/reports/recent_transactions.json', {
          options: this.options,
        }, null, this.$store.state.auth.entities[0]).then(resp => {
          this.items = resp.data
          this.total = resp.total
        }).finally(() => {
          this.loading = false
        })

      }
    },
  }
</script>
